webpackJsonp([35783957827783],{

/***/ 266:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  padding: 1rem;\n  max-width: 30rem;\n'], ['\n  padding: 1rem;\n  max-width: 30rem;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  line-height: 3rem;\n  font-size: 3rem;\n  margin: ', ' 0;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n\n  a {\n    color: hsla(0,0%,0%,0.7)\n  }\n'], ['\n  line-height: 3rem;\n  font-size: 3rem;\n  margin: ', ' 0;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n\n  a {\n    color: hsla(0,0%,0%,0.7)\n  }\n']);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(48);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _typography = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var IndexContainer = _styledComponents2.default.div(_templateObject);
	
	var Line = _styledComponents2.default.p(_templateObject2, (0, _typography.rhythm)(1.5));
	
	var Index = function (_React$Component) {
	  _inherits(Index, _React$Component);
	
	  function Index() {
	    _classCallCheck(this, Index);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Index.prototype.render = function render() {
	    return _react2.default.createElement(
	      IndexContainer,
	      null,
	      _react2.default.createElement(
	        Line,
	        null,
	        'Hi! My name is William Chiu.'
	      ),
	      _react2.default.createElement(
	        Line,
	        null,
	        'My friends call me Billy Chiu\u2014I am...'
	      ),
	      _react2.default.createElement(
	        Line,
	        null,
	        'An aspiring full stack developer'
	      ),
	      _react2.default.createElement(
	        Line,
	        null,
	        'The 142nd Head of Product at the',
	        " ",
	        _react2.default.createElement(
	          'a',
	          { href: 'http://www.columbiaspectator.com/' },
	          'Columbia Daily Spectator'
	        )
	      ),
	      _react2.default.createElement(
	        Line,
	        null,
	        'A software engineering intern at',
	        " ",
	        _react2.default.createElement(
	          'a',
	          { href: 'https://eegent.com/' },
	          'EEG'
	        )
	      ),
	      _react2.default.createElement(
	        Line,
	        null,
	        'Previously, a software engineering intern at',
	        " ",
	        _react2.default.createElement(
	          'a',
	          { href: 'http://diditlabs.com/' },
	          'DIDiT'
	        )
	      ),
	      _react2.default.createElement(
	        Line,
	        null,
	        'Pleasure to meet you!'
	      )
	    );
	  };
	
	  return Index;
	}(_react2.default.Component);
	
	exports.default = Index;
	
	
	exports.frontmatter = {
	  title: "Home",
	  inChilly: true
	};
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-0e39fd49e6c3b63158c3.js